import { render, staticRenderFns } from "./EditPrecioSinRecintoModal.vue?vue&type=template&id=00c6f3a5"
import script from "./EditPrecioSinRecintoModal.vue?vue&type=script&lang=js"
export * from "./EditPrecioSinRecintoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports